import is from 'is_js';
import * as moment from 'moment';

export function validateDateOfBirth(str) {
    return moment(str, "YYYY-MM-DD", true).isValid();
}

export function validateAge(str) {
    let dob = moment(str);
    let limit = moment();
    limit=limit.subtract(16, 'years');
    if(dob.isSameOrAfter(limit)){
        return true;
    } else {
        return false;
    }
}

//Initially returns true for a 0 value but will be checked again on blur

export function validateDay(day, month){
    var pattern = /^([1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
    day = day.padStart(2, "0");

    if(day.match(pattern)){
        // if(month !== null && month != 'undefined' && month!= ''){
        //     //Maybe skip this until after year to see if full date is valid
        //     return moment((month+"-"+day), "MM-DD", true).isValid();
        // }else{
            if(Number(day) !== NaN && Number(day) <= 31 && Number(day) > 0){
                return true;
            } else{
                return false;
            }
        // }
    }else{
        return false;
    }
}

export function validateMonth(str, day) {
    var pattern = /^([1-9]|0[1-9]|1[0-2])$/;
    if(str.match(pattern)){
        // if(day !== null && day != 'undefined' && day!= ''){
        //     return validateDay(day.padStart(2,"0"), str.padStart(2, "0"));
        // }else{
            return moment(str.padStart(2, "0"), "MM", true).isValid();
        // }
    }
    return false;
}

export function validateDateMonth(str){
    return moment((str), "DD-MM", true).isValid();
}

export function validateYear(str) {
    var pattern = /^[0-9]{4}$/;
    if(str.match(pattern)){
        let inputStr = '';
        let upperLimit = moment();
        let lowerLimit = moment('1900');
        inputStr = moment(str, "YYYY");
        return inputStr.isSameOrAfter(lowerLimit,'year') && upperLimit.isSameOrAfter(inputStr, 'year');
    }
    return false
}


// export function validateDay(day, month) {
//     var pattern = /^(0|[1-9]|0[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
//     if(day === '0')
//     {
//         day = day.padStart(2,"1");
//     }
//     else{
//         day = day.padStart(2, "0");
//     }
//     if(day.match(pattern)){
//         if(month !== null && month != 'undefined' && month!= ''){
//             return moment((month+"-"+day), "MM-DD", true).isValid();
//         } else{
//             if(Number(day) !== NaN && Number(day) <= 31 && Number(day) >= 0){
//                 return true;
//             } else{
//                 return false;
//             }
//         }
//     }
// }

// export function validateMonth(str, day) {
//     var pattern = /^(0|1|0[1-9]|1[0-2])$/;
//     if (str ===""){
//         return true;
//     }
//     if(str.match(pattern)){
//         if(day !== null && day != 'undefined' && day!= ''){
//             if(str ==="0"){
//                 return true;
//             }
//             return validateDay(day.padStart(2,"0"), str.padStart(2, "0"));
//         }
//         return moment(str.padStart(2, "0"), "MM", true).isValid();
//     }
//     return false;
// }

// export function validateYear(str) {
//     var pattern = /^[0-9]{0,4}$/;
//     if(str.match(pattern)){
//         let inputStr = '';
//         let upperLimit = moment();
//         let lowerLimit = moment('1900');
//         if(str.length === 2){
//             inputStr = moment('00'+str, "YYYY");
//         } else {
//             inputStr = moment(str, "YYYY");
//         }
//         return inputStr.isSameOrAfter(lowerLimit,'year') && upperLimit.isSameOrAfter(inputStr, 'year');
//     }
//     return false
// }

export function validateMedicareNumber(str) {
    var pattern = /^[0-9]{0,9}$/;
    if(str.match(pattern)){
        return true;
    }
    return false;
}

export function validateRegNumber(str) {
    var pattern = /^[A-Za-z0-9]+$/;
    if(str.match(pattern)) {
        return true;
    }
    return false;
}

export function validateFirstName(str) {
    var pattern = /^[A-Za-z\s-'\u2018\u2019\u0060.]+$/;
    if(str.match(pattern)) {
        return true;
    }
    return false;
}

export function validateLastName(str) {
    var pattern = /^[A-Za-z\s-'\u2018\u2019\u0060.]+$/;
    if(str.match(pattern))
    {
        return true;
    }
    return false;
}

export function validateExpirationMonth(str) {
   
    var pattern = /^[0-9]{0,2}$/;
    //PK: Lone '0' is not a valid month, so validator will fail and nothing will appear in text box.
    if(str === '0' || str === undefined || str === ''){
        return true;
    }
    if(str.match(pattern)) {
        let inputStr = moment(str, "MM");
        return inputStr.isValid();
    }
    return false;
}

export function validateExpirationYear(str) {
    var pattern = /^[0-9{4}]*$/;
    if(str.match(pattern)) {
        // Expiration year must be between 1920 and 2050
        let inputStr = moment(str, "YYYY");
        return inputStr.isValid();
    }
    return false;

}

export function validateMedicareExpiry(str) {
    return moment(str, "MM/YYYY", true).isValid();
}

export function validatePostalCode(str) {
    if (is.caPostalCode(str)) {
        return true;
    }
    return false;
}